"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiValueContainer = exports.MultiValueRemove = exports.OptionMultiple = exports.OptionLocation = exports.OptionBasic = exports.NoOptionsMessage = exports.ClearIndicator = exports.DropdownIndicator = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _checkThin = _interopRequireDefault(require("../../../icons/check-thin"));

var _close = _interopRequireDefault(require("../../../icons/close"));

var _mapMarker = _interopRequireDefault(require("../../../icons/map-marker"));

var _triangleDown = _interopRequireDefault(require("../../../icons/triangle-down"));

var _text = require("../../text");

var _select = require("./select.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DropdownIndicator = function DropdownIndicator(props) {
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.DropdownIndicator, props, /*#__PURE__*/_react.default.createElement("span", {
    className: "react-select__dropdown-indicator-inner"
  }, /*#__PURE__*/_react.default.createElement(_triangleDown.default, {
    measure: 8,
    color: "gray800"
  })));
};

exports.DropdownIndicator = DropdownIndicator;

var ClearIndicator = function ClearIndicator(props) {
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.ClearIndicator, props, /*#__PURE__*/_react.default.createElement("span", {
    className: "react-select__clear-btn"
  }, /*#__PURE__*/_react.default.createElement(_close.default, {
    measure: 10,
    color: "black"
  })));
};

exports.ClearIndicator = ClearIndicator;

var NoOptionsMessage = function NoOptionsMessage(props) {
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.NoOptionsMessage, props, /*#__PURE__*/_react.default.createElement("span", {
    className: "react-select__no-result"
  }, "No results found"));
};

exports.NoOptionsMessage = NoOptionsMessage;

var OptionBasic = function OptionBasic(props) {
  var data = props.data,
      children = props.children;
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.Option, props, (data === null || data === void 0 ? void 0 : data.hex) && /*#__PURE__*/_react.default.createElement(_select.ColorMarkOption, {
    $color: data.hex
  }), /*#__PURE__*/_react.default.createElement(_select.OptionTextStyled, null, children), /*#__PURE__*/_react.default.createElement("span", {
    className: "react-select__check-ico"
  }, /*#__PURE__*/_react.default.createElement(_checkThin.default, {
    measure: 16,
    color: "success"
  })));
};

exports.OptionBasic = OptionBasic;

var OptionLocation = function OptionLocation(props) {
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.Option, _extends({}, props, {
    className: "react-select__location-wrap"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "react-select__location-icon"
  }, /*#__PURE__*/_react.default.createElement(_mapMarker.default, {
    measure: 22
  })), props.children);
};

exports.OptionLocation = OptionLocation;

var OptionMultiple = function OptionMultiple(props) {
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.Option, props, /*#__PURE__*/_react.default.createElement("span", {
    className: "react-select-creatable__check-block"
  }, /*#__PURE__*/_react.default.createElement(_checkThin.default, {
    measure: 8
  })), props.children);
};

exports.OptionMultiple = OptionMultiple;

var MultiValueRemove = function MultiValueRemove(props) {
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.MultiValueRemove, props, /*#__PURE__*/_react.default.createElement(_close.default, {
    measure: 10,
    color: "black"
  }));
};

exports.MultiValueRemove = MultiValueRemove;

var MultiValueContainer = function MultiValueContainer(props) {
  var _props$selectProps = props.selectProps,
      showMultiOptionsCount = _props$selectProps.showMultiOptionsCount,
      value = _props$selectProps.value,
      children = props.children;
  var optionsCount = value.length || 1;
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.MultiValueContainer, props, showMultiOptionsCount ? /*#__PURE__*/_react.default.createElement(_text.Text, {
    fontWeight: "light",
    measure: "xxs",
    color: "gray800",
    as: "span",
    uppercase: true,
    letterSpacing: 1.65
  }, optionsCount > 1 ? "".concat(optionsCount, " selected") : value.label || value[0].label) : children);
};

exports.MultiValueContainer = MultiValueContainer;